import { configureStore } from "@reduxjs/toolkit";
import consentReducer from "./src/components/cookie-consent/consentSlice";

export default configureStore({
  reducer: {
    consent: consentReducer,
  },
});
